import { FETCH_HOME, FETCH_HOME_START } from '../actions';

const initialState = {
    fetched: false,
    failed: false,
    posts: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_HOME_START:
            return {
                ...state,
                fetched: false,
                content: [],
            };
        case FETCH_HOME:
            return {
                ...state,
                fetched: true,
                content: action.payload,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/home_reducer.jsx